import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import CardDropDownMenuItem from '../card-dropdown-menu-item/card-dropdown-menu-item.component'

import { useSelector } from 'react-redux'
import { selectIsLoading } from '@selectors'

import { DropDown, IconInline, Loader, WHITE } from '@omnilert/components'

import useStyles from './card-dropdown.style'

const CardDropdown = ({ data, direction }) => {
  const { menu, variant } = data
    
  const classes = useStyles()

  const dropDownRef = useRef(null)

  const isLoading = useSelector(selectIsLoading)

  const isSubmittingAction = isLoading.some(item => menu?.find(({ postData }) => postData.id === item?.meta))

  const handleOnClick = () => dropDownRef.current.close()

  const renderIcon = () => {
    if (isSubmittingAction) {
      return <Loader
        className={classes.loader}
        color={WHITE}
        size='lg'
      />
    } else {
      return (
        <IconInline
          className={classes.toggleButton}
          name='three-dots'
          rotate={90}
          size={34}
        />
      )
    }
  }

  if (!menu) return null

  return (
    <DropDown
      ref={dropDownRef}
      direction={direction}
      toggleComponent={renderIcon()}
    >
      {menu.map((data, i) => (
        <CardDropDownMenuItem
          key={`item-${i}`}
          className={classes.dropdownItem}
          data={data}
          onClick={handleOnClick}
          variant={variant}
        />
      ))}
    </DropDown>
  )
}

CardDropdown.defaultProps = {
  direction: 'bottom',
  data: null
}

CardDropdown.propTypes = {
  direction: PropTypes.string,
  data: PropTypes.object.isRequired
}

export default CardDropdown
